import React, { useMemo } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { getHuggg } from 'redux/modules/huggg';
import MerchantTerms from './Redeem/MerchantTerms';
import ScreensLanding from './Landing/Landing';
import ScreenError from './Error';
import ScreensLogin from './Login/Login';
import ScreensHowToRedeem from './Redeem/HowToRedeem';
import ScreensHugggStashed from './Huggg/Stashed';
import ScreensMoreDetails from './MoreDetails/MoreDetails';
import ScreensMyHugggs from './MyHugggs/MyHugggs';
import ScreensRedeem from './Redeem/Redeem';
import ScreensRedeemed from './Redeem/Redeemed';
import ScreensSuperhugggStashed from './Superhuggg/Stashed';
import ScreensTestRedeemed from './Redeem/TestRedeemed';
import ScreenChoose from './Choose/Choose';
import ScreensUnstashed from './Unstashed/UnstashedContainer';
import { PrivateRoute } from 'components';
import { OfflineBanner as UIOfflineBanner } from 'components/ui';
import { ScrollToTop } from 'components/misc';
import {
  ThemeContextProvider,
  Heading_4 as Typography
} from '@huggg/react-components';
import { getThemeModelLoader } from 'utilities/getThemeModelLoader';
import HistoryService from 'services/HistoryService';
import styles from './root.module.scss';
import PropTypes from 'prop-types';
import ScheduledMaintenanceBanner from 'components/ui/ScheduledMaintenanceBanner/ScheduledMaintenanceBanner';

const history = new HistoryService();

export const ScreensRoot = ({ huggg }) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  const { theme, modelLoader } = useMemo(() => {
    return getThemeModelLoader(huggg?.theme_info);
  }, [huggg?.theme_info]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <ThemeContextProvider modelLoader={modelLoader} theme={theme}>
      <Typography className={styles.root}>
        <Router history={history}>
          <ScrollToTop>
            <ScheduledMaintenanceBanner />
            <UIOfflineBanner className={styles.offlineBanner} />

            <Switch>
              <Route path="/error" component={ScreenError} />

              {theme === 'default' && (
                <Route path="/login" component={ScreensLogin} />
              )}

              <Route
                path="/super/:shortcode/stashed"
                component={ScreensSuperhugggStashed}
              />

              {/* Shared Routes */}
              <Route
                path="/(super|test)?/:shortcode"
                exact
                component={ScreensLanding}
              />
              <Route
                path="/(super|test)?/:shortcode/more-information"
                component={ScreensMoreDetails}
              />
              <Route
                path="/(super|test)?/:shortcode/stash"
                component={ScreensUnstashed}
              />
              <Route
                path="/(super|test)?/:shortcode/(merchant|partner)-terms"
                component={MerchantTerms}
              />

              {/* Regular Huggg Routes */}
              <Route
                path="/(test)?/:shortcode/redeemed"
                component={ScreensRedeemed}
              />
              <Route
                path="/(test)?/:shortcode/choose"
                component={ScreenChoose}
              />
              <Route
                path="/(test)?/:shortcode/redeem"
                component={ScreensRedeem}
              />
              <Route
                path="/(test)?/:shortcode/stashed"
                component={ScreensHugggStashed}
              />
              <Route
                path="/(test)?/:shortcode/how-to-redeem"
                component={ScreensHowToRedeem}
              />

              <Route
                path="/test/:shortcode/test-redeemed"
                component={ScreensTestRedeemed}
              />

              <PrivateRoute path="/" exact component={ScreensMyHugggs} />
              <Route
                component={() => {
                  return (
                    <ScreenError errorMessage="Sorry, what you're looking for can't be found." />
                  );
                }}
              />
            </Switch>
          </ScrollToTop>
        </Router>
      </Typography>
    </ThemeContextProvider>
  );
};

ScreensRoot.propTypes = {
  huggg: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    huggg: getHuggg(state)
  };
};

export default connect(mapStateToProps)(ScreensRoot);
